import React from 'react';
import ReactDOM from 'react-dom/client';
import RocheStore from './RocheStore';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RocheStore />
  </React.StrictMode>
);
